export enum WorkType {
  REMOTE = 'REMOTE',
  HYBRID = 'HYBRID',
  ON_SITE = 'ON_SITE',
}

export enum ReportPeriod {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum EnglishLevel {
  NO_ENGLISH = 'NO_ENGLISH',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  UPPER_INTERMEDIATE = 'UPPER_INTERMEDIATE',
  ADVANCED = 'ADVANCED',
  FLUENT = 'FLUENT',
}

export enum Degree {
  NO_DEGREE = 'NO_DEGREE',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  ASSOCIATE = 'ASSOCIATE',
  BACHELOR = 'BACHELOR',
  MASTER = 'MASTER',
  DOCTORATE = 'DOCTORATE',
}

export enum ApprovedStatusType {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  REVOKED = 'REVOKED',
  REVOKE_PENDING_HR_APPROVAL = 'REVOKE_PENDING_HR_APPROVAL',
  REVOKE_PENDING_EMPLOYEE_APPROVAL = 'REVOKE_PENDING_EMPLOYEE_APPROVAL',
}

export enum WorkPlanEntryType {
  NORMAL = 'NORMAL',
  OVERTIME = 'OVERTIME',
  WEEKEND = 'WEEKEND',
}

export enum ExpenseStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  REIMBURSED = 'REIMBURSED',
}

export enum LeaveType {
  SICK = 'SICK',
  BEREAVEMENT_IMMEDIATE_FAMILY = 'BEREAVEMENT_IMMEDIATE_FAMILY',
  BEREAVEMENT_OTHER = 'BEREAVEMENT_OTHER',
  UNPAID = 'UNPAID',
  ANNUAL = 'ANNUAL',
  MATERNITY = 'MATERNITY',
  PATERNITY = 'PATERNITY',
  MARRIAGE = 'MARRIAGE',
  EXCUSE = 'EXCUSE',
  OTHER = 'OTHER',
}

export enum DayPortion {
  ALL_DAY = 'ALL_DAY',
  BEFORE_NOON = 'BEFORE_NOON',
  AFTERNOON = 'AFTERNOON',
}

export enum ProjectPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  CRITICAL = 'Critical',
}

export enum Permission {
  // === EMPLOYEE MANAGEMENT ===
  EMPLOYEE_CREATE = 1,
  EMPLOYEE_UPDATE_ALL = 2,
  EMPLOYEE_READ_ALL = 3,
  EMPLOYEE_DELETE = 4,
  EMPLOYEE_READ_SALARY = 5,
  EMPLOYEE_UPDATE_SALARY = 6,

  // === CANDIDATE MANAGEMENT ===
  CANDIDATE_CREATE = 7,
  CANDIDATE_UPDATE = 8,
  CANDIDATE_READ = 9,
  CANDIDATE_DELETE = 10,

  // === POSITION MANAGEMENT ===
  POSITION_CREATE = 11,
  POSITION_UPDATE = 12,
  POSITION_READ = 13,
  POSITION_DELETE = 14,

  // === TITLE MANAGEMENT ===
  TITLE_CREATE = 15,
  TITLE_UPDATE = 16,
  TITLE_READ = 17,
  TITLE_DELETE = 18,

  // === SKILL MANAGEMENT ===
  SKILL_CREATE = 19,
  SKILL_UPDATE = 20,
  SKILL_READ = 21,
  SKILL_DELETE = 22,

  // === COMPANY & CONTACT MANAGEMENT ===
  COMPANY_CREATE = 23,
  COMPANY_UPDATE = 24,
  COMPANY_READ = 25,
  COMPANY_DELETE = 26,

  // === LEAVE MANAGEMENT ===
  LEAVES_APPROVE = 27,
  LEAVES_READ_ALL = 28,
  LEAVES_CREATE_OWN = 29,
  LEAVES_READ_OWN = 30,

  // === ROLE & PERMISSION MANAGEMENT ===
  ROLES_CREATE = 31,
  ROLES_UPDATE = 32,
  ROLES_READ = 33,
  ROLES_DELETE = 34,

  // === CUSTOMER COMPANY ===
  CUSTOMER_COMPANY_READ = 35,
  CUSTOMER_COMPANY_MANAGE = 36,

  // === ANNOUNCEMENTS ===
  ANNOUNCEMENT_MANAGE = 37,

  // === EXPENSE MANAGEMENT ===
  EXPENSE_READ_ALL = 38,
  EXPENSE_UPDATE_STATUS = 39,
  EXPENSE_DELETE_ALL = 40,

  // === OVERTIME MANAGEMENT ===
  OVERTIME_EVALUATE = 41,
  OVERTIME_READ_ALL = 42,
  OVERTIME_MANAGE_APPROVED = 43,

  // === INTERVIEW MANAGEMENT ===
  INTERVIEW_MANAGE = 44,
  INTERVIEW_CREATE = 45,
  INTERVIEW_READ = 46,

  LEAVE_POLICY_MANAGE = 47,

  GROUP_CREATE = 48,
  GROUP_READ_ALL = 49,
  GROUP_DELETE = 50,

  GROUP_UPDATE = 51,
  GROUP_MEMBER_ADD = 52,
  GROUP_MEMBER_REMOVE = 53,
  GROUP_MEMBER_UPDATE = 54,
  GROUP_MEMBER_READ = 55,

  // === FORM360 - TEMPLATES ===
  FORM360_TEMPLATE_READ = 56,
  FORM360_TEMPLATE_CREATE = 57,
  FORM360_TEMPLATE_UPDATE = 58,
  FORM360_TEMPLATE_DELETE = 59,

  // === FORM360 - EVALUATIONS ===
  FORM360_EVALUATION_READ = 60,
  FORM360_EVALUATION_CREATE = 61,
  FORM360_EVALUATION_UPDATE = 62,
  FORM360_EVALUATION_DELETE = 63,

  // === GROUP MANAGEMENT (EXTRA) ===
  GROUP_MANAGE = 64,

  // === ANNOUNCEMENTS (COMPANY) ===
  ANNOUNCEMENT_COMPANY_MANAGE = 65,

  // === CANDIDATE KVKK ===
  CANDIDATE_KVKK_MANAGE = 66,

  // === TEAM MANAGEMENT ===
  TEAM_CREATE = 67,

  // === EMPLOYEE MANAGER ===
  EMPLOYEE_MANAGER_READ = 68,
  EMPLOYEE_MANAGER_ASSIGN = 69,
  EMPLOYEE_MANAGER_REMOVE = 70,

  // === UNIVERSITY MANAGEMENT ===
  UNIVERSITY_CREATE = 71,
  UNIVERSITY_READ = 72,
  UNIVERSITY_UPDATE = 73,
  UNIVERSITY_DELETE = 74,

  // === GOALS (OKR) ===
  GOAL_READ = 75,
  GOAL_CREATE = 76,
  GOAL_UPDATE = 77,
  GOAL_DELETE = 78,
  GOAL_KEY_RESULT_APPROVE = 79,
  GOAL_KEY_RESULT_UPDATE = 80,

  // === C-LEVEL HIERARCHY ===
  CLEVEL_HIERARCHY_MANAGE = 81,

  // === ORGANIZATION HIERARCHY ===
  ORGANIZATION_HIERARCHY_MANAGE = 82,

  // === ACCOUNT SETTINGS ===
  ACCOUNT_SETTINGS_MANAGE = 83,

  // === RECRUITMENT REPORTS ===
  RECRUITMENT_REPORT_READ = 84,

  // === OFFBOARDING (under Employees) ===
  EMPLOYEE_OFFBOARDING_MANAGE = 85,

  // === INVENTORY / ASSET MANAGEMENT ===
  // Granular HR permissions (no blanket "manage" — each action is gated separately).
  // Read all company inventory (the "Çalışan Envanterleri" tab, detail, by-employee).
  INVENTORY_READ_ALL = 87,
  // View decrypted device access credentials (passwords/PINs). Sensitive; audited.
  // Employees can always see their OWN device creds (self-service, no permission).
  INVENTORY_ACCESS_VIEW = 88,
  // Create a new inventory item.
  INVENTORY_CREATE = 91,
  // Edit an item's descriptive fields (name/brand/serial…) + assign/status/receive.
  INVENTORY_UPDATE = 92,
  // Delete (soft) an item.
  INVENTORY_DELETE = 93,
  // Approve/reject an employee-submitted inventory record.
  INVENTORY_APPROVE = 94,

  // === JOB LISTINGS (Peoply Kariyer) ===
  // Publish/extend/withdraw a position's public job listing.
  JOB_LISTING_MANAGE = 95,
  // See applications that arrived through job listings.
  JOB_APPLICATION_READ = 96,
  // Set application status/notes and transfer applications to the pipeline.
  JOB_APPLICATION_MANAGE = 97,
  // NOTE: employee self-service (/inventory/me/*) needs NO permission — like Leave
  // self-service it relies on authMiddleware + requireModule and the service scopes
  // to context.employeeId, so no INVENTORY_*_OWN permissions exist.
}

export enum Availability {
  AVAILABLE = 'AVAILABLE',
  ON_LEAVE = 'ON_LEAVE',
  // ASSIGNED/BENCH retired — availability is automated purely from leave state
  // (ON_LEAVE while an approved leave covers today, otherwise AVAILABLE); there are
  // no projects. TERMINATED was retired earlier (now EmploymentPeriod.status).
}

// ── Offboarding / employment-period lifecycle (mirror of Prisma enums) ──────────
export enum EmploymentStatus {
  ACTIVE = 'ACTIVE',
  OFFBOARDING = 'OFFBOARDING',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

/**
 * Statuses of an employee who is still with the company — actively working (ACTIVE) or
 * in their notice period (OFFBOARDING). Excludes INACTIVE/ARCHIVED (already left). Use this
 * as the single source of truth for "still-employed" filters — e.g. birthday/anniversary
 * notifications, attrition analytics, low-leave-balance alerts — so a departed employee
 * (period INACTIVE) is not treated as current. Replaces the retired
 * `availability != 'TERMINATED'` check.
 */
export const EMPLOYED_STATUSES: readonly EmploymentStatus[] = [
  EmploymentStatus.ACTIVE,
  EmploymentStatus.OFFBOARDING,
];

export enum OffboardingType {
  RESIGNATION = 'RESIGNATION',
  TERMINATION_BY_EMPLOYER = 'TERMINATION_BY_EMPLOYER',
}

export enum OffboardingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
}

export enum OffboardingDocStatus {
  PENDING = 'PENDING',
  WAITING_EMPLOYEE = 'WAITING_EMPLOYEE',
  WAITING_HR = 'WAITING_HR',
  UNDER_REVIEW = 'UNDER_REVIEW',
  NEEDS_CORRECTION = 'NEEDS_CORRECTION',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
}

export enum OffboardingResponsible {
  EMPLOYEE = 'EMPLOYEE',
  HR = 'HR',
}

export enum OffboardingDocType {
  RESIGNATION_LETTER = 'RESIGNATION_LETTER',
  TERMINATION_NOTICE = 'TERMINATION_NOTICE',
  LEAVE_ENTITLEMENT = 'LEAVE_ENTITLEMENT',
  INVENTORY_RETURN = 'INVENTORY_RETURN',
  RELEASE_WAIVER = 'RELEASE_WAIVER',
  EXIT_CERTIFICATE = 'EXIT_CERTIFICATE',
  PAYROLL = 'PAYROLL',
}

export enum NoticePaymentStatus {
  NONE = 'NONE',
  PENDING = 'PENDING',
  PAID = 'PAID',
}

// ── Inventory / asset management (mirror of Prisma enums) ───────────────────────
export enum InventoryStatus {
  PENDING_DELIVERY = 'PENDING_DELIVERY', // Teslim Bekliyor
  WITH_EMPLOYEE = 'WITH_EMPLOYEE', // Çalışanda
  RETURN_PENDING = 'RETURN_PENDING', // İade Bekliyor
  RETURNED = 'RETURNED', // İade Edildi
  DAMAGED = 'DAMAGED', // Hasarlı
  LOST = 'LOST', // Kayıp
  SCRAPPED = 'SCRAPPED', // Hurda
  TRANSFERRED = 'TRANSFERRED', // Devredildi
}

// Orthogonal to InventoryStatus — HR-created records are auto-APPROVED, employee-
// created records start PENDING_HR_APPROVAL.
export enum InventoryApprovalStatus {
  APPROVED = 'APPROVED',
  PENDING_HR_APPROVAL = 'PENDING_HR_APPROVAL',
  REJECTED = 'REJECTED',
}

export enum InventoryAccessCredentialType {
  COMPUTER_PASSWORD = 'COMPUTER_PASSWORD',
  PHONE_PIN = 'PHONE_PIN',
  TABLET_PASSWORD = 'TABLET_PASSWORD',
  USERNAME = 'USERNAME',
  OTHER = 'OTHER',
}

export enum InventoryAuditAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  ASSIGNED = 'ASSIGNED',
  DELIVERY_CONFIRMED = 'DELIVERY_CONFIRMED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  RETURN_INITIATED = 'RETURN_INITIATED',
  RETURNED = 'RETURNED',
  // HR took the asset back directly (no employee return request preceded it).
  TAKEN_BACK = 'TAKEN_BACK',
  TRANSFERRED = 'TRANSFERRED',
  APPROVAL_REQUESTED = 'APPROVAL_REQUESTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CREDENTIAL_VIEWED = 'CREDENTIAL_VIEWED',
  CREDENTIAL_UPDATED = 'CREDENTIAL_UPDATED',
  ATTACHMENT_ADDED = 'ATTACHMENT_ADDED',
  ATTACHMENT_REMOVED = 'ATTACHMENT_REMOVED',
}

// The seeded default inventory type keys (madde 6). "OTHER" must always be present.
// Companies may add custom types later; these are the global defaults.
export const DEFAULT_INVENTORY_TYPES: readonly { key: string; label: string }[] = [
  { key: 'COMPUTER', label: 'Bilgisayar' },
  { key: 'PHONE', label: 'Telefon' },
  { key: 'TABLET', label: 'Tablet' },
  { key: 'MONITOR', label: 'Monitör' },
  { key: 'KEYBOARD', label: 'Klavye' },
  { key: 'MOUSE', label: 'Mouse' },
  { key: 'HEADSET', label: 'Kulaklık' },
  { key: 'CHARGER', label: 'Şarj cihazı' },
  { key: 'ADAPTER', label: 'Adaptör' },
  { key: 'SIM_CARD', label: 'SIM kart' },
  { key: 'COMPANY_CAR', label: 'Şirket aracı' },
  { key: 'OTHER', label: 'Diğer' },
];

// ── Type-specific inventory fields (madde: türe göre değişen alanlar) ─────────────
// Extra attributes rendered in the add/edit form and validated on the server per
// `typeKey`. Stored in Inventory.customFields (JSON). Keys must be stable — renaming a
// key orphans stored values. `labelKey` points at an i18n string
// (inventory.customFields.<key>); the enum label here is only a Turkish fallback.
export type InventoryFieldType = 'text' | 'number' | 'date' | 'select';

export interface InventoryTypeFieldDef {
  key: string;
  label: string; // Turkish fallback; UI resolves inventory.customFields.<key>
  type: InventoryFieldType;
  required?: boolean;
  options?: readonly string[]; // for type === 'select'
  maxLength?: number;
}

// Types not listed here (e.g. MONITOR, KEYBOARD…) have no extra fields — only the
// common name/brand/model/serial columns apply.
export const INVENTORY_TYPE_FIELDS: Readonly<Record<string, readonly InventoryTypeFieldDef[]>> = {
  SIM_CARD: [
    { key: 'phoneNumber', label: 'Telefon numarası', type: 'text', maxLength: 32, required: true },
    { key: 'operator', label: 'Operatör', type: 'text', maxLength: 64 },
    { key: 'iccid', label: 'ICCID / Seri no', type: 'text', maxLength: 32 },
    { key: 'pukCode', label: 'PUK kodu', type: 'text', maxLength: 16 },
    { key: 'dataPlan', label: 'Tarife / paket', type: 'text', maxLength: 120 },
  ],
  PHONE: [
    { key: 'imei', label: 'IMEI', type: 'text', maxLength: 32 },
    { key: 'phoneNumber', label: 'Telefon numarası', type: 'text', maxLength: 32 },
    { key: 'color', label: 'Renk', type: 'text', maxLength: 40 },
    { key: 'storage', label: 'Depolama', type: 'text', maxLength: 40 },
  ],
  COMPUTER: [
    { key: 'cpu', label: 'İşlemci', type: 'text', maxLength: 80 },
    { key: 'ram', label: 'RAM', type: 'text', maxLength: 40 },
    { key: 'storage', label: 'Depolama', type: 'text', maxLength: 40 },
    { key: 'os', label: 'İşletim sistemi', type: 'text', maxLength: 60 },
    { key: 'macAddress', label: 'MAC adresi', type: 'text', maxLength: 32 },
  ],
  TABLET: [
    { key: 'imei', label: 'IMEI / Seri no', type: 'text', maxLength: 32 },
    { key: 'storage', label: 'Depolama', type: 'text', maxLength: 40 },
    { key: 'color', label: 'Renk', type: 'text', maxLength: 40 },
  ],
  COMPANY_CAR: [
    { key: 'plate', label: 'Plaka', type: 'text', maxLength: 16, required: true },
    { key: 'vin', label: 'Şasi no (VIN)', type: 'text', maxLength: 32 },
    { key: 'year', label: 'Model yılı', type: 'number' },
    { key: 'mileage', label: 'Kilometre', type: 'number' },
    {
      key: 'fuelType',
      label: 'Yakıt tipi',
      type: 'select',
      options: ['GASOLINE', 'DIESEL', 'LPG', 'ELECTRIC', 'HYBRID'],
    },
    { key: 'inspectionDate', label: 'Muayene tarihi', type: 'date' },
    { key: 'insuranceExpiry', label: 'Sigorta bitiş tarihi', type: 'date' },
  ],
};


// How the statutory job-search leave (Turkish Labour Law art. 27) is taken during
// the notice period — by agreement between employee and employer.
export enum JobSearchLeaveMode {
  DAILY = 'DAILY', // Spread daily across the notice period
  END_OF_NOTICE = 'END_OF_NOTICE', // Taken in one block at the end of the notice
}

export enum SalaryType {
  GROSS = 'GROSS',
  NET = 'NET',
}

export enum PaymentPeriod {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export const MILITARY_DOCUMENT_KEY = 'militaryStatusCertificate' as const;
export const MILITARY_DEPLOYMENT_DOCUMENT_KEY = 'militaryDeploymentCertificate' as const;
export const DIPLOMA_DOCUMENT_KEY = 'diplomaOrGraduationCertificate' as const;
export const MASTERS_DOCUMENT_KEY = 'mastersDegreeCertificate' as const;
export const STUDENT_DOCUMENT_KEY = 'studentCertificate' as const;
export const MARRIAGE_DOCUMENT_KEY = 'marriageCertificateCopy' as const;

export const onboardingDocumentList = [
  { key: 'identityCardCopy', name: 'Copy of Identity Card' },
  { key: 'populationRegistryExtract', name: 'Population Registry Extract' },
  { key: 'residenceCertificate', name: 'Certificate of Residence' },
  { key: 'healthReport', name: 'Health Report' },
  { key: DIPLOMA_DOCUMENT_KEY, name: 'Copy of Diploma | Graduation Certificate' },
  { key: MASTERS_DOCUMENT_KEY, name: "Master's Degree Certificate" },
  { key: STUDENT_DOCUMENT_KEY, name: 'Student Certificate' },
  { key: 'criminalRecord', name: 'Criminal Record' },
  { key: 'passportPhoto', name: 'Passport Photo' },
  { key: 'familyStatusDeclaration', name: 'Family Status Declaration' },
  { key: MARRIAGE_DOCUMENT_KEY, name: 'Marriage Certificate Copy' },
  { key: MILITARY_DOCUMENT_KEY, name: 'Military Status Certificate' },
  { key: MILITARY_DEPLOYMENT_DOCUMENT_KEY, name: 'Military Deployment Certificate' },
  { key: 'bankSalaryAccount', name: 'Bank Salary Account Information' },
  { key: 'iskurRegistration', name: 'İşkur Registration' },
  { key: 'updatedCV', name: 'Updated CV' },
  { key: 'indefiniteTermEmploymentContract', name: 'Indefinite Term Employment Contract' },
  { key: 'employeeExplicitConsent', name: 'Employee Explicit Consent Statement' },
  { key: 'codefirstEmployeeDisclosure', name: 'Codefirst Employee Disclosure Statement' },
  { key: 'kvkkConfidentialityUndertaking', name: 'KVKK Employee Confidentiality Undertaking' },
  { key: 'acceptableUsePolicy', name: 'Acceptable Use Policy' },
];

export enum PositionModel {
  INHOUSE = 'IN_HOUSE',
  OUTSOURCE = 'OUTSOURCE',
  HYBRID = 'HYBRID',
}

export enum Seniority {
  INTERN = 'INTERN',
  JUNIOR = 'JUNIOR',
  MID = 'MID',
  SENIOR = 'SENIOR',
  LEAD = 'LEAD',
  MANAGER = 'MANAGER',
  DIRECTOR = 'DIRECTOR',
  PRINCIPAL = 'PRINCIPAL',
}

export enum Status {
  ACTIVE = 'ACTIVE',
  ON_HOLD = 'ON_HOLD',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
  CANCELLED = 'CANCELLED',
}

export enum Currency {
  TRY = 'TRY',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export type OnboardingDocumentDefinition = (typeof onboardingDocumentList)[number];

export const requiresMilitaryDocument = (gender?: Gender | string | null): boolean => {
  if (gender == null) return true;

  switch (gender) {
    case Gender.FEMALE:
      return false;
    case Gender.MALE:
      return true;
    default: {
      // Unknown or legacy gender value — require the document as a safe fallback.
      // If Gender enum gains a new value, add it here explicitly.
      const _exhaustiveCheck: never = gender as never;
      void _exhaustiveCheck;
      return true;
    }
  }
};

export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
}

/** Minimal education entry shape needed to resolve document requirements. */
export type OnboardingEducationInfo = {
  degree?: string | null;
  isOngoing?: boolean | null;
};

/** Employee attributes that drive conditional onboarding document requirements. */
export type OnboardingDocumentProfile = {
  gender?: Gender | string | null;
  maritalStatus?: MaritalStatus | string | null;
  education?: OnboardingEducationInfo[] | null;
};

const completedEducations = (education?: OnboardingEducationInfo[] | null): OnboardingEducationInfo[] =>
  (education ?? []).filter((entry) => entry != null && entry.isOngoing !== true);

const ongoingEducations = (education?: OnboardingEducationInfo[] | null): OnboardingEducationInfo[] =>
  (education ?? []).filter((entry) => entry?.isOngoing === true);

export const requiresMarriageDocument = (maritalStatus?: MaritalStatus | string | null): boolean =>
  maritalStatus === MaritalStatus.MARRIED;

export const requiresMastersDocument = (education?: OnboardingEducationInfo[] | null): boolean =>
  completedEducations(education).some((entry) => entry.degree === Degree.MASTER);

// A student certificate is only asked from employees who have no completed degree yet:
// once any diploma exists it covers the education requirement (customer decision, 2026-08-06).
export const requiresStudentDocument = (education?: OnboardingEducationInfo[] | null): boolean =>
  ongoingEducations(education).length > 0 && completedEducations(education).length === 0;

// With no education data at all we keep the historical behavior (diploma required),
// so existing profiles without education entries don't silently lose the requirement.
export const requiresDiplomaDocument = (education?: OnboardingEducationInfo[] | null): boolean => {
  const entries = (education ?? []).filter((entry) => entry != null);
  if (entries.length === 0) return true;
  return completedEducations(entries).length > 0;
};

// Offboarding documents (severance release, resignation letter, termination
// certificate) only make sense once the employee is leaving, so they stay hidden
export const getRequiredOnboardingDocuments = (
  profile?: OnboardingDocumentProfile | null
): OnboardingDocumentDefinition[] => {
  const { gender, maritalStatus, education } = profile ?? {};

  return onboardingDocumentList.filter((doc) => {
    switch (doc.key) {
      case MILITARY_DOCUMENT_KEY:
      case MILITARY_DEPLOYMENT_DOCUMENT_KEY:
        return requiresMilitaryDocument(gender);
      case MARRIAGE_DOCUMENT_KEY:
        return requiresMarriageDocument(maritalStatus);
      case MASTERS_DOCUMENT_KEY:
        return requiresMastersDocument(education);
      case STUDENT_DOCUMENT_KEY:
        return requiresStudentDocument(education);
      case DIPLOMA_DOCUMENT_KEY:
        return requiresDiplomaDocument(education);
      default:
        return true;
    }
  });
};

export enum EmergencyContactType {
  FRIEND = 'FRIEND',
  FAMILY = 'FAMILY',
  SPOUSE = 'SPOUSE',
  PARTNER = 'PARTNER',
  OTHER = 'OTHER',
}

export enum EmploymentType {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  CONTRACT = 'CONTRACT',
  INTERN = 'INTERN',
}

export enum ScoringRuleType {
  SCORE = 'SCORE',
  PENALTY = 'PENALTY',
  FILTER = 'FILTER',
}

export enum EvaluatorKey {
  SKILL_MUST_HAVE = 'SKILL_MUST_HAVE',
  SKILL_PREFERRED = 'SKILL_PREFERRED',
  SKILL_PREFERRED_DIMINISHING = 'SKILL_PREFERRED_DIMINISHING',
  EXPERIENCE_MIN_YEARS = 'EXPERIENCE_MIN_YEARS',
  EXPERIENCE_SIGMOID = 'EXPERIENCE_SIGMOID',
  SENIORITY_MATCH = 'SENIORITY_MATCH',
  SENIORITY_ELIMINATE = 'SENIORITY_ELIMINATE',
  LOCATION_MATCH = 'LOCATION_MATCH',
  LANGUAGE_PROFICIENCY = 'LANGUAGE_PROFICIENCY',
  EDUCATION_LEVEL_MATCH = 'EDUCATION_LEVEL_MATCH',
  EDUCATION_INSTITUTION_MATCH = 'EDUCATION_INSTITUTION_MATCH',
  SALARY_EXPECTATION = 'SALARY_EXPECTATION',
  TITLE_MATCH = 'TITLE_MATCH',
}

export const evaluatorKeyName = {
  SKILL_MUST_HAVE: 'Must-Have Skill',
  SKILL_PREFERRED: 'Preferred Skill',
  SKILL_PREFERRED_DIMINISHING: 'Preferred Skill (Diminishing Return)',
  EXPERIENCE_MIN_YEARS: 'Minimum Years of Experience',
  EXPERIENCE_SIGMOID: 'Experience Scoring (Sigmoid)',
  SENIORITY_MATCH: 'Seniority Level Match',
  SENIORITY_ELIMINATE: 'Seniority Level Elimination',
  LOCATION_MATCH: 'Location Match',
  LANGUAGE_PROFICIENCY: 'Language Proficiency',
  EDUCATION_LEVEL_MATCH: 'Education Level Match',
  EDUCATION_INSTITUTION_MATCH: 'Education Institution Match',
  SALARY_EXPECTATION: 'Salary Expectation',
  TITLE_MATCH: 'Title Match',
} as const;

/**
 * Score components the match engine appends on its own (scoring v2). They are NOT
 * user-creatable rules, so they intentionally live outside `EvaluatorKey`: the rule
 * editor, position wizard and rule validation only know `EvaluatorKey` members.
 */
export const ImplicitScoreKey = {
  REQUIRED_SKILL_COVERAGE: 'REQUIRED_SKILL_COVERAGE',
  TITLE_SIMILARITY: 'TITLE_SIMILARITY',
  SKILL_FOCUS: 'SKILL_FOCUS',
} as const;

export type ImplicitScoreKey = (typeof ImplicitScoreKey)[keyof typeof ImplicitScoreKey];

export const implicitScoreKeyName: Record<ImplicitScoreKey, string> = {
  REQUIRED_SKILL_COVERAGE: 'Required Skill Coverage',
  TITLE_SIMILARITY: 'Title Similarity',
  SKILL_FOCUS: 'Skill Focus',
};

export const isImplicitScoreKey = (key: string): key is ImplicitScoreKey =>
  Object.prototype.hasOwnProperty.call(implicitScoreKeyName, key);

/**
 * Scoring v2: a SCORE component that was "not applicable / unknown" for this pair is stored with
 * weight 0 and `meta.abstained = true`. It never affects the score; UIs should hide it.
 */
export const isAbstainedMatchDetail = (detail: { meta?: unknown } | null | undefined): boolean => {
  const meta = detail?.meta;
  return typeof meta === 'object' && meta !== null && (meta as { abstained?: unknown }).abstained === true;
};

export enum HistoryType {
  PROCESS_UPDATE = 'PROCESS_UPDATE',
  NOTE = 'NOTE',
  FEEDBACK = 'FEEDBACK',
}

export type ExpenseCategory =
  | 'TRAVEL_FLIGHT'
  | 'TRAVEL_TRAIN'
  | 'TRAVEL_TAXI_RIDESHARE'
  | 'TRAVEL_RENTAL_CAR'
  | 'TRAVEL_MILEAGE'
  | 'TRAVEL_ACCOMMODATION'
  | 'MEAL_EMPLOYEE'
  | 'MEAL_CLIENT_ENTERTAINMENT'
  | 'OFFICE_SUPPLIES'
  | 'OFFICE_RENT_UTILITIES'
  | 'SOFTWARE_SUBSCRIPTIONS'
  | 'HARDWARE'
  | 'EDUCATION_CONFERENCE'
  | 'EDUCATION_COURSE_TRAINING'
  | 'EDUCATION_BOOKS_MATERIALS'
  | 'COMMUNICATION_PHONE_BILL'
  | 'COMMUNICATION_INTERNET'
  | 'OTHER';

export const expenseCategories: ExpenseCategory[] = [
  'TRAVEL_FLIGHT',
  'TRAVEL_TRAIN',
  'TRAVEL_TAXI_RIDESHARE',
  'TRAVEL_RENTAL_CAR',
  'TRAVEL_MILEAGE',
  'TRAVEL_ACCOMMODATION',
  'MEAL_EMPLOYEE',
  'MEAL_CLIENT_ENTERTAINMENT',
  'OFFICE_SUPPLIES',
  'OFFICE_RENT_UTILITIES',
  'SOFTWARE_SUBSCRIPTIONS',
  'HARDWARE',
  'EDUCATION_CONFERENCE',
  'EDUCATION_COURSE_TRAINING',
  'EDUCATION_BOOKS_MATERIALS',
  'COMMUNICATION_PHONE_BILL',
  'COMMUNICATION_INTERNET',
  'OTHER',
];

export const expenseCategoryOptions = {
  TRAVEL_FLIGHT: 'Travel: Flight Ticket',
  TRAVEL_TRAIN: 'Travel: Train Ticket',
  TRAVEL_TAXI_RIDESHARE: 'Travel: Taxi / Rideshare',
  TRAVEL_RENTAL_CAR: 'Travel: Rental Car',
  TRAVEL_ACCOMMODATION: 'Travel: Accommodation',
  TRAVEL_MILEAGE: 'Travel: Mileage Claim',
  MEAL_EMPLOYEE: 'Meal: Employee Meal',
  MEAL_CLIENT_ENTERTAINMENT: 'Meal: Client Entertainment',
  OFFICE_SUPPLIES: 'Office: Supplies',
  OFFICE_RENT_UTILITIES: 'Office: Rent & Utilities',
  SOFTWARE_SUBSCRIPTIONS: 'Office: Software & Subscriptions',
  HARDWARE: 'Office: Hardware',
  EDUCATION_CONFERENCE: 'Development: Conference',
  EDUCATION_COURSE_TRAINING: 'Development: Course & Training',
  EDUCATION_BOOKS_MATERIALS: 'Development: Books & Materials',
  COMMUNICATION_PHONE_BILL: 'Communication: Phone Bill',
  COMMUNICATION_INTERNET: 'Communication: Internet Bill',
  OTHER: 'Other',
} as const;

export const employmentTypeOptions = {
  FULL_TIME: 'Full-Time',
  PART_TIME: 'Part-Time',
  CONTRACT: 'Contract',
  INTERN: 'Intern',
} as const;

export type EmploymentTypeKey = keyof typeof employmentTypeOptions;

export const workTypeOptions = {
  REMOTE: 'Remote',
  HYBRID: 'Hybrid',
  ON_SITE: 'On Site',
} as const;

export const positionModelOptions = {
  IN_HOUSE: 'In House',
  OUTSOURCE: 'Outsource',
  HYBRID: 'Hybrid',
} as const;

export enum NoteCategory {
  GENERAL = 'GENERAL',
  TECHNICAL = 'TECHNICAL',
  COMMUNICATION = 'COMMUNICATION',
}

export enum RoleType {
  Admin = 'Admin',
  HR = 'HR',
  Friendly = 'Friendly',
  Employee = 'Employee',
  // Founder of a listing-only company.
  ListingAdmin = 'ListingAdmin',
}

// Mirror of the Prisma CompanyAccountType enum.
export enum CompanyAccountType {
  LISTING_ONLY = 'LISTING_ONLY',
  FULL = 'FULL',
}

// The sector a company picks at sign-up (kept in Company.industry); OTHER when none fits.
export enum CompanySector {
  SOFTWARE_TECHNOLOGY = 'SOFTWARE_TECHNOLOGY',
  FINANCE_BANKING_FINTECH = 'FINANCE_BANKING_FINTECH',
  ECOMMERCE_RETAIL = 'ECOMMERCE_RETAIL',
  MARKETING_ADVERTISING_MEDIA = 'MARKETING_ADVERTISING_MEDIA',
  MANUFACTURING_AUTOMOTIVE = 'MANUFACTURING_AUTOMOTIVE',
  HR_CONSULTING = 'HR_CONSULTING',
  HEALTHCARE = 'HEALTHCARE',
  CONSTRUCTION_REAL_ESTATE_ENGINEERING = 'CONSTRUCTION_REAL_ESTATE_ENGINEERING',
  LOGISTICS_SUPPLY_CHAIN = 'LOGISTICS_SUPPLY_CHAIN',
  CUSTOMER_SERVICE_BPO = 'CUSTOMER_SERVICE_BPO',
  EDUCATION = 'EDUCATION',
  LEGAL = 'LEGAL',
  TOURISM_HOSPITALITY = 'TOURISM_HOSPITALITY',
  ENERGY = 'ENERGY',
  OTHER = 'OTHER',
}

// Mirror of the Prisma CompanyPlanChangeStatus enum (a move between listing-only and full use).
export enum CompanyPlanChangeStatus {
  SCHEDULED = 'SCHEDULED',
  APPLIED = 'APPLIED',
  CANCELLED = 'CANCELLED',
}

// Mirror of the Prisma CompanyPlanChangeSource enum: who changed the plan.
export enum CompanyPlanChangeSource {
  COMPANY = 'COMPANY',
  SUPERADMIN = 'SUPERADMIN',
}

// Mirror of the Prisma JobListingStatus enum.
export enum JobListingStatus {
  DRAFT = 'DRAFT',
  // Credit already spent; goes live at scheduledAt.
  SCHEDULED = 'SCHEDULED',
  PUBLISHED = 'PUBLISHED',
  EXPIRED = 'EXPIRED',
  UNPUBLISHED = 'UNPUBLISHED',
}

// Mirror of the Prisma JobListingTier enum.
export enum JobListingTier {
  STANDARD = 'STANDARD',
}

// Mirror of the Prisma JobCreditSource enum.
export enum JobCreditSource {
  WELCOME = 'WELCOME',
  PURCHASE = 'PURCHASE',
  PLAN = 'PLAN',
  REFUND = 'REFUND',
  SPEND = 'SPEND',
}

// Mirror of the Prisma CandidateProfileVisibility enum: who can see a candidate's profile.
export enum CandidateProfileVisibility {
  APPLIED_COMPANIES_ONLY = 'APPLIED_COMPANIES_ONLY',
  OPEN_TO_RECRUITERS = 'OPEN_TO_RECRUITERS',
}

// Mirror of the Prisma CvTemplate enum: the Peoply CV design a candidate's profile is laid out in.
export enum CvTemplate {
  CLASSIC = 'CLASSIC',
  MODERN = 'MODERN',
  MINIMAL = 'MINIMAL',
  CORPORATE = 'CORPORATE',
  EXECUTIVE = 'EXECUTIVE',
  TIMELINE = 'TIMELINE',
  CREATIVE = 'CREATIVE',
}

// Mirror of the Prisma CvColor enum: the color a candidate picks for their CV template (none =
// the template's own colors).
export enum CvColor {
  BLUE = 'BLUE',
  TEAL = 'TEAL',
  GREEN = 'GREEN',
  PURPLE = 'PURPLE',
  CRIMSON = 'CRIMSON',
  ORANGE = 'ORANGE',
  SLATE = 'SLATE',
}

// Mirror of the Prisma JobApplicationCvSource enum: the CV that went with an application —
// the profile laid out in the chosen template, or the PDF the candidate uploaded.
export enum JobApplicationCvSource {
  TEMPLATE = 'TEMPLATE',
  UPLOAD = 'UPLOAD',
}

// A missing piece of a candidate's profile the CV coach suggests completing.
export enum CandidateProfileTip {
  ADD_CV = 'ADD_CV',
  ADD_HEADLINE = 'ADD_HEADLINE',
  ADD_SUMMARY = 'ADD_SUMMARY',
  EXPAND_SUMMARY = 'EXPAND_SUMMARY',
  ADD_CITY = 'ADD_CITY',
  ADD_EXPERIENCE = 'ADD_EXPERIENCE',
  DESCRIBE_EXPERIENCE = 'DESCRIBE_EXPERIENCE',
  ADD_EDUCATION = 'ADD_EDUCATION',
  ADD_SKILLS = 'ADD_SKILLS',
  ADD_LANGUAGES = 'ADD_LANGUAGES',
  ADD_DESIRED_POSITIONS = 'ADD_DESIRED_POSITIONS',
  ADD_WORK_TYPES = 'ADD_WORK_TYPES',
}

// Why a job listing was recommended to a candidate.
export enum JobRecommendationReason {
  SKILLS = 'SKILLS',
  TITLE = 'TITLE',
  WORK_TYPE = 'WORK_TYPE',
  LOCATION = 'LOCATION',
}

// Where a Peoply Kariyer candidate can sign in besides e-mail and password (URL segment).
export enum CandidateOAuthProvider {
  GOOGLE = 'google',
}

// Mirror of the Prisma JobApplicationStatus enum. The candidate sees the same status the
// company sets; WITHDRAWN is set only by the candidate.
export enum JobApplicationStatus {
  NEW = 'NEW',
  REVIEWING = 'REVIEWING',
  INTERVIEW = 'INTERVIEW',
  OFFER = 'OFFER',
  HIRED = 'HIRED',
  REJECTED = 'REJECTED',
  WITHDRAWN = 'WITHDRAWN',
}

// Where an application came from, for the company's filter: the candidate answered the company's
// talent pool invitation, or applied on their own.
export enum JobApplicationSource {
  INVITED = 'INVITED',
  DIRECT = 'DIRECT',
}

// Mirror of the Prisma CandidateInvitationStatus enum: a company's invitation to apply to one
// of its listings. ACCEPTED once the candidate applied; DECLINED when they turned it down.
export enum CandidateInvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}

// Why a publish request left the listing as a draft instead of publishing it.
export enum JobListingPublishBlockReason {
  NO_CREDIT = 'NO_CREDIT',
}

// İlan ↔ aday eşleşme kuralları. Sunucu eşleştirmesi ve ilan verene gösterilen kural özeti aynı
// değerleri kullanır. Yayınlanacak ilanın pozisyonunda en az bu kadar zorunlu yetenek olmalı.
export const JOB_LISTING_MIN_SKILLS = 2;
// Adayın ilanın zorunlu yeteneklerinden en az bu kadarına (benzerleri dahil) sahip olması gerekir;
// tercih edilen yetenekler adayı elemez, yalnızca sıralamayı etkiler.
export const JOB_LISTING_MATCH_MIN_SKILLS = 2;
// Adayın deneyimi pozisyonun istediği en az yıldan bu kadar eksik olabilir.
export const JOB_LISTING_MATCH_EXPERIENCE_TOLERANCE_YEARS = 3;

// How the recurring billing cron charges a group of subscription items:
// RENEWAL — due ACTIVE items; a failed charge marks them PAST_DUE and notifies.
// RETRY — items already PAST_DUE; a failed charge leaves them as they are, success reactivates.
export enum RecurringChargeMode {
  RENEWAL = 'RENEWAL',
  RETRY = 'RETRY',
}

export enum NotificationType {
  NEW_ANNOUNCEMENT = 'NEW_ANNOUNCEMENT',
  UPDATED_ANNOUNCEMENT = 'UPDATED_ANNOUNCEMENT',
  LEAVE_REQUEST_CREATED = 'LEAVE_REQUEST_CREATED',
  LEAVE_REQUEST_PROCESSED = 'LEAVE_REQUEST_PROCESSED',
  EXPENSE_REQUEST_CREATED = 'EXPENSE_REQUEST_CREATED',
  EXPENSE_REQUEST_PROCESSED = 'EXPENSE_REQUEST_PROCESSED',
  OVERTIME_REQUEST_CREATED = 'OVERTIME_REQUEST_CREATED',
  OVERTIME_REQUEST_PROCESSED = 'OVERTIME_REQUEST_PROCESSED',
  CONNECTION_REQUEST_RECEIVED = 'CONNECTION_REQUEST_RECEIVED',
  CONNECTION_REQUEST_UPDATED = 'CONNECTION_REQUEST_UPDATED',
  CONNECTION_REQUEST_REJECTED = 'CONNECTION_REQUEST_REJECTED',
  POSITION_SHARED = 'POSITION_SHARED',
  NEW_EVALUATION = 'NEW_EVALUATION',
  EVALUATION_COMPLETED = 'EVALUATION_COMPLETED',
  UNKNOWN = 'UNKNOWN',
  INTERVIEW_ASSIGNED = 'INTERVIEW_ASSIGNED',
  INTERVIEW_UPDATED = 'INTERVIEW_UPDATED',
  INTERVIEW_CANCELLED = 'INTERVIEW_CANCELLED',
  MEET_ASSIGNED = 'MEET_ASSIGNED',
  MEET_UPDATED = 'MEET_UPDATED',
  MEET_CANCELLED = 'MEET_CANCELLED',
  EXPENSE_CREATED = 'EXPENSE_CREATED',
  EXPENSE_APPROVED = 'EXPENSE_APPROVED',
  EXPENSE_REJECTED = 'EXPENSE_REJECTED',
  EXPENSE_CANCELLED = 'EXPENSE_CANCELLED',

  LEAVE_APPROVED = 'LEAVE_APPROVED',
  LEAVE_REJECTED = 'LEAVE_REJECTED',
  LEAVE_CANCELLED = 'LEAVE_CANCELLED',

  OVERTIME_CREATED = 'OVERTIME_CREATED',
  OVERTIME_APPROVED = 'OVERTIME_APPROVED',
  OVERTIME_REJECTED = 'OVERTIME_REJECTED',
  GOAL_ASSIGNED = 'GOAL_ASSIGNED',
  GOAL_PROGRESS_APPROVAL_REQUESTED = 'GOAL_PROGRESS_APPROVAL_REQUESTED',
  GOAL_PROGRESS_APPROVED = 'GOAL_PROGRESS_APPROVED',
  GOAL_PROGRESS_REJECTED = 'GOAL_PROGRESS_REJECTED',
  GOAL_COMPLETED = 'GOAL_COMPLETED',
  GOAL_DEADLINE_APPROACHING = 'GOAL_DEADLINE_APPROACHING',
  EVALUATION_DEADLINE_APPROACHING = 'EVALUATION_DEADLINE_APPROACHING',
  TIMESHEET_DEADLINE_APPROACHING = 'TIMESHEET_DEADLINE_APPROACHING',

  // Inventory / asset management (mirror of the Prisma enum values added in
  // 20260922130000_add_inventory_notification_types).
  INVENTORY_ASSIGNED = 'INVENTORY_ASSIGNED', // İK → çalışan: yeni envanter atandı, teslim onayı bekleniyor
  INVENTORY_SUBMITTED = 'INVENTORY_SUBMITTED', // çalışan → İK: yeni envanter kaydı oluşturuldu, onay bekliyor
  INVENTORY_RETURN_REQUESTED = 'INVENTORY_RETURN_REQUESTED', // İK/sistem → çalışan: envanterin iadesi bekleniyor
  INVENTORY_RETURN_REQUEST_SUBMITTED = 'INVENTORY_RETURN_REQUEST_SUBMITTED', // çalışan → İK: envanter iade talebi oluşturuldu, onay bekliyor
  INVENTORY_RETURN_REJECTED = 'INVENTORY_RETURN_REJECTED', // İK → çalışan: iade talebi reddedildi, cihaz sizde kalıyor
  INVENTORY_APPROVED = 'INVENTORY_APPROVED', // İK → çalışan: envanter kaydı onaylandı
  INVENTORY_REJECTED = 'INVENTORY_REJECTED', // İK → çalışan: envanter kaydı reddedildi
  JOB_APPLICATION_RECEIVED = 'JOB_APPLICATION_RECEIVED', // aday → firma: ilana yeni başvuru
}

export enum CompanyStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PROSPECT = 'PROSPECT',
}

export enum CompanyType {
  INVITED = 'INVITED',
  ORGANIC = 'ORGANIC',
  SELF_SIGNUP = 'SELF_SIGNUP',
}

export enum ChatRole {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
  SYSTEM = 'SYSTEM',
  TOOL = 'TOOL',
}

export const ProjectName = 'Peoply';

export enum Evaluation360Status {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
}

export enum Question360Type {
  RATING_SCALE = 'RATING_SCALE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  OPEN_ENDED = 'OPEN_ENDED',
}

export enum Form360TemplateStatus {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
}

export enum GoalType {
  INDIVIDUAL = 'INDIVIDUAL',
  TEAM = 'TEAM',
  GROUP = 'GROUP',
}

export enum GoalPeriod {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
}

export enum GoalStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
}

export enum KeyResultType {
  NUMERIC = 'NUMERIC',
  CHECKLIST = 'CHECKLIST',
}

export enum KeyResultStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}

export enum CandidateStatus {
  ACTIVE = 'ACTIVE',
  INTERVIEWING = 'INTERVIEWING',
  HIRED = 'HIRED',
  REJECTED = 'REJECTED',
}

export enum GroupAuthorityType {
  HR_AUTHORITY = 'HR_AUTHORITY',
  OPERATIONAL_AUTHORITY = 'OPERATIONAL_AUTHORITY',
}

export enum SeatStatus {
  ACTIVE = 'ACTIVE',
  RESERVED = 'RESERVED',
  UNASSIGNED = 'UNASSIGNED',
}

export enum KvkkStatusType {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  NOT_SENT = 'NOT_SENT',
}

/** Question mix asked of exam-engine when a question set is generated. */
export enum InterviewQuestionFormat {
  OPEN_ENDED = 'OPEN_ENDED',
  MCQ = 'MCQ',
  MIXED = 'MIXED',
}

/** Type of a single generated question — a MIXED set holds both kinds. */
export enum InterviewQuestionType {
  OPEN_ENDED = 'OPEN_ENDED',
  MCQ = 'MCQ',
}

/** The answer keys exam-engine grades an MCQ against. */
export enum InterviewMcqOption {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

/**
 * A MIXED set is MCQ plus open-ended, so it cannot be met by a single question.
 * The client floors the requested count here; the server refuses an mcqCount
 * that would leave nothing open-ended.
 */
export const INTERVIEW_MIXED_MIN_QUESTIONS = 2;

/** How many questions one generation request may ask exam-engine for. */
export const INTERVIEW_QUESTION_COUNT_MIN = 1;
export const INTERVIEW_QUESTION_COUNT_MAX = 20;
export const INTERVIEW_QUESTION_COUNT_DEFAULT = 8;

/**
 * Expected interview length, in minutes, handed to the generator as context.
 *
 * The floor is exam-engine's — it refuses anything under 15 with a 400. Ours used
 * to be 5, so a recruiter could type a duration the request would then fail on,
 * with nothing on screen explaining why. The ceiling is ours alone; exam-engine
 * does not impose one.
 */
export const INTERVIEW_DURATION_MIN_MINUTES = 15;
export const INTERVIEW_DURATION_MAX_MINUTES = 180;

/**
 * How long a candidate's interview link stays usable, in days. Whoever sends the
 * interview picks the number.
 *
 * The bounds are enforced twice, on purpose. Here at the edge the request schema
 * rejects anything outside them with a 400: a caller asking for 100 days is asking
 * for something this API does not offer, and quietly handing back a 90-day link
 * would hide that. Inside exam-engine the same bounds clamp instead — whatever
 * reaches it has already passed the edge, and a shorter link beats no session at
 * all. The modal clamps the field before it sends, so the 400 is a guard against
 * other callers rather than something a recruiter can walk into.
 */
export const INTERVIEW_VALIDITY_MIN_DAYS = 1;
export const INTERVIEW_VALIDITY_MAX_DAYS = 90;
export const INTERVIEW_VALIDITY_DEFAULT_DAYS = 14;

/**
 * Used to give the candidate a rough idea of how long the interview takes.
 *
 * Only a fallback. exam-engine now stamps the requested duration on the question
 * set and reports it at session creation, so this is used for sets generated
 * before it started doing so. Anything derived from it must be presented as
 * approximate — see estimateInterviewDurationMinutes.
 */
export const INTERVIEW_ESTIMATED_MINUTES_PER_QUESTION = 3;

/** Estimates round to this, so a derived figure never reads as an exact one. */
export const INTERVIEW_DURATION_ROUNDING_MINUTES = 5;

/**
 * The fallback interview length for a question set the engine has no duration
 * for. Null when there is nothing to work from.
 *
 * Shared rather than duplicated per caller because the invitation and every
 * resend after it must quote the same figure: a candidate told forty minutes
 * once and forty-five the next time has been told the first was wrong.
 */
export const estimateInterviewDurationMinutes = (questionCount: number | null): number | null => {
  if (questionCount === null || questionCount <= 0) return null;

  const raw = questionCount * INTERVIEW_ESTIMATED_MINUTES_PER_QUESTION;
  return Math.max(
    INTERVIEW_DURATION_ROUNDING_MINUTES,
    Math.round(raw / INTERVIEW_DURATION_ROUNDING_MINUTES) * INTERVIEW_DURATION_ROUNDING_MINUTES
  );
};

/**
 * Outcome of the interview invitation email, as Peoply recorded it.
 *
 * Mirrors the Prisma enum of the same name. NOT_SENT covers both "the sender
 * asked us not to" and "not attempted yet"; the two are distinguished by
 * whether a send was requested, not by a separate member.
 */
export enum InterviewEmailStatus {
  NOT_SENT = 'NOT_SENT',
  SENT = 'SENT',
  FAILED = 'FAILED',
  SKIPPED_NO_ADDRESS = 'SKIPPED_NO_ADDRESS',
}

/**
 * How far along a sent interview is, as Peoply records it.
 *
 * Mirrors the Prisma enum of the same name; the server asserts the two stay in
 * step at compile time. EXPIRED has no engine counterpart — the engine keeps
 * reporting IN_PROGRESS for a link that can no longer be opened, so Peoply
 * derives expiry from the deadline rather than being told about it.
 */
export enum InterviewSubmissionStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

/**
 * Events exam-engine dispatches to the Assessment webhook endpoint, carried in
 * the `X-Webhook-Event` header. The same values are also written into the
 * `candidateActivity.content` JSON the timeline reads back, so these strings
 * are persisted history — renaming a member would orphan existing rows.
 */
export enum AssessmentWebhookEvent {
  EXAM_COMPLETED = 'EXAM_COMPLETED',
  EXAM_ASSIGNED = 'EXAM_ASSIGNED',
  CANDIDATE_DELETED = 'CANDIDATE_DELETED',
  INTERVIEW_COMPLETED = 'INTERVIEW_COMPLETED',
}

export const DASHBOARD_UPDATE_TRIGGERS = [
  NotificationType.EXPENSE_CREATED,
  NotificationType.EXPENSE_APPROVED,
  NotificationType.EXPENSE_REJECTED,
  NotificationType.EXPENSE_CANCELLED,

  NotificationType.LEAVE_REQUEST_CREATED,
  NotificationType.LEAVE_APPROVED,
  NotificationType.LEAVE_REJECTED,
  NotificationType.LEAVE_CANCELLED,

  NotificationType.OVERTIME_CREATED,
  NotificationType.OVERTIME_APPROVED,
  NotificationType.OVERTIME_REJECTED,
];

export const MODULE_KEYS = {
  // Used by requireModule middleware, the SuperAdmin package panel, and seed migrations.
  CANDIDATES: 'candidates',
  POSITIONS: 'positions',
  CLIENTS: 'clients',
  CONNECTIONS: 'connections',
  CANDIDATE_MATCHING: 'candidate-matching',
  EMPLOYEES: 'employees',
  LEAVE: 'leave',
  EXPENSES: 'expenses',
  OVERTIME: 'overtime',
  EVALUATIONS: 'evaluations',
  GOALS: 'goals',
  CHATBOT: 'chatbot',
  ANNOUNCEMENTS: 'announcements',
  SKILLS_AND_TITLES: 'skills-and-titles',
  SETTINGS: 'settings',
  GROUPS: 'groups',
  CALENDAR: 'calendar',
  ASSESSMENTS: 'assessments',
  GAMES: 'games',
  REPORTS: 'reports',
  INVENTORY: 'inventory',
  JOB_LISTINGS: 'job-listings',
} as const;

export type ModuleKey = (typeof MODULE_KEYS)[keyof typeof MODULE_KEYS];

// ISO 3166-1 alpha-2 codes of the countries a company or a candidate signs up from. Listings and
// candidates are matched within one country unless a country filter asks for others.
export const COUNTRY_CODES = [
  'TR', 'US', 'GB', 'DE', 'FR', 'NL', 'BE', 'CH', 'AT', 'SE', 'NO', 'DK', 'FI', 'IT', 'ES', 'PT', 'PL', 'CZ',
  'HU', 'RO', 'BG', 'GR', 'HR', 'SK', 'SI', 'LT', 'LV', 'EE', 'IE', 'LU', 'MT', 'CY', 'RU', 'UA', 'AZ', 'GE',
  'AM', 'KZ', 'UZ', 'TM', 'KG', 'TJ', 'SA', 'AE', 'QA', 'KW', 'BH', 'OM', 'JO', 'LB', 'IQ', 'IR', 'SY', 'EG',
  'LY', 'TN', 'DZ', 'MA', 'SD', 'ET', 'KE', 'NG', 'ZA', 'GH', 'SN', 'CN', 'JP', 'KR', 'IN', 'PK', 'BD', 'ID',
  'MY', 'SG', 'TH', 'VN', 'PH', 'HK', 'TW', 'AU', 'NZ', 'CA', 'MX', 'BR', 'AR', 'CL', 'CO', 'PE', 'VE', 'IL',
  'AF', 'IS', 'AL', 'RS', 'BA', 'ME', 'MK', 'XK', 'MD', 'BY',
] as const;

export type CountryCode = (typeof COUNTRY_CODES)[number];

// The country of companies and candidates from before the country was asked at sign-up.
export const DEFAULT_COUNTRY_CODE: CountryCode = 'TR';

export const isCountryCode = (value: unknown): value is CountryCode =>
  typeof value === 'string' && (COUNTRY_CODES as readonly string[]).includes(value);
